// extracted by mini-css-extract-plugin
var _1 = "RequestBoardCardHead-moduleRequestBoardCardHead__wv6ZP";
var _2 = "RequestBoardCardHead-moduleactions__SmuR1";
var _3 = "RequestBoardCardHead-modulerequestNo__WDNqJ EntityLink-moduleEntityLink__AOulJ";
export { _1 as "RequestBoardCardHead", _2 as "actions", _3 as "requestNo" }
